import { defineComponent as _defineComponent } from 'vue'
import HotelDescriptionMainText from './hotelDescriptionMainText/HotelDescriptionMainText.vue';
    import HotelDescriptionLocation from './hotelDescriptionLocation/HotelDescriptionLocation.vue';
    import HotelDescriptionTerritory from './hotelDescriptionTerritory/HotelDescriptionTerritory.vue';
    import HotelDescriptionImportant from './hotelDescriptionImportant/HotelDescriptionImportant.vue';
    import HotelDescriptionFacilities from './hotelDescriptionFacilities/HotelDescriptionFacilities.vue';
    import HotelDescriptionNote from './hotelDescriptionNote/HotelDescriptionNote.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'HotelDescription',
  setup(__props) {

    
return { __sfc: true,HotelDescriptionMainText, HotelDescriptionLocation, HotelDescriptionTerritory, HotelDescriptionImportant, HotelDescriptionFacilities, HotelDescriptionNote }
}

})